import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as valueType from './value-type'

export const INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.dms.data.query.Variable,
    graphql.schema.VariableInput
  >({
    defaultValue: graphql.transformers.IN.stringify(),
    description: transformers.PASS_THROUGH,
    id: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
    type: valueType.INPUT,
  }),
)
